import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, Grid2 as Grid, TextField, IconButton, InputAdornment } from "@mui/material"
import { AddCircle, RemoveCircle } from '@mui/icons-material';

import { myTimestampToDate } from "../utils/ui_utils"
import { differenceInCalendarMonths } from 'date-fns';


export const MyInput = ({ type, label, id, value, onChange, isError }) => {
    if (type === 'date') {
        return (
            <DatePicker
                variant="outlined"
                label={label}
                name={id}
                id={id}
                slotProps={{ field: { size: 'small' } }}
                value={myTimestampToDate(value)}
                onChange={(nv) => onChange({ target: { value: nv, name: id } })} />
        )
    } else {
        return (
            <TextField
                margin="dense"
                id={id}
                size="small"
                label={label}
                fullWidth
                name={id}
                error={isError}
                variant="outlined"
                value={value}
                onChange={onChange}
            />
        )

    }
}

const margin_top = '0.8'

export const MyInputAdvance = ({ type, label, id, value, onChange, min_value, btn }) => {

    const incrementValue = () => {
        onChange({ target: { value: parseInt(value) + 1, name: id } })
    }

    const decrementValue = () => {
        onChange({ target: { value: parseInt(value) - 1, name: id } })
    }

    if (type === 'date') {
        const v = myTimestampToDate(value)
        const diff = value ? differenceInCalendarMonths(new Date(), v) + ' mesi' : ''

        return (
            <Grid container sx={{ alignItems: 'center', mt: margin_top }}>
                <Grid xs={6}>
                    <DatePicker
                        variant="outlined"
                        size="small"
                        label={label} name={id} id={id}
                        value={v}
                        onChange={(nv) => onChange({ target: { value: nv, name: id } })} />
                </Grid>
                <Grid xs={6} sx={{ ml: 1 }}>
                    {diff}
                </Grid>
            </Grid>
        )

    } else if (type === 'number') {

        return (

            <Box sx={{ mt: margin_top }}>

                <TextField
                    margin="dense"
                    id={id}
                    label={label}
                    name={id}
                    variant="outlined"
                    value={value}
                    size="small"
                    onChange={(ev) => onChange(ev)}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton edge="end" color="primary" onClick={() => incrementValue(id)}>
                                    <AddCircle />
                                </IconButton>
                            </InputAdornment>
                        ),
                        startAdornment: (
                            <InputAdornment position="start">
                                <IconButton disabled={parseInt(value) <= min_value} edge="start" color="primary" onClick={() => decrementValue(id)}>
                                    <RemoveCircle />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
        )

    } else {
        return (
            <TextField
                size="small"
                sx={{ mt: margin_top }}
                id={id}
                label={label}
                fullWidth
                name={id}
                variant="outlined"
                value={value}
                onChange={onChange}
                InputProps={btn && {
                    endAdornment: (btn)
                }}
            />
        )

    }
}

